// Local product data synced with Stripe
// This file was auto-generated from Discogs collection on 2026-02-12T14:32:23.231Z
// Collection: https://www.discogs.com/user/josharagon/collection
//
// Each product includes Stripe Product and Price IDs for checkout
// To update prices, modify them in Stripe Dashboard and re-run this sync

const products = [
  {
    id: "founding-tee",
    handle: "spinnin-beans-founding-tee",
    title: "Spinnin' Beans Founding Tee",
    productType: "Apparel",
    inventoryQuantity: 5,
    descriptionHtml: `<p>Be part of the Spinnin' Beans movement from day one. The Founding Tee is for the heads who live in playlists, crate-dig at 2 a.m., and care way too much (in the best way) about good music.</p><p>Oversized, boxy, drop-shoulder fit with a comfort, care-free look and feel that's ready to throw on any day of the week. Wear it to the club, the coffee shop, or the studio — and let people know you were here at the start.</p> <p>*Includes Lifetime Spinnin' Beans Pro Subscription*</p>`,
    variants: [
      {
        id: "founding-tee-s",
        title: "S",
        price: { amount: "50.00", currencyCode: "USD" },
        stripePriceId: "price_1T74m1JUsO4JXEem1cHQn8yT",
      },
      {
        id: "founding-tee-m",
        title: "M",
        price: { amount: "50.00", currencyCode: "USD" },
        stripePriceId: "price_1T74mCJUsO4JXEemDyIqVGiW",
      },
      {
        id: "founding-tee-l",
        title: "L",
        price: { amount: "50.00", currencyCode: "USD" },
        stripePriceId: "price_1T74mDJUsO4JXEemSorevVEb",
      },
      {
        id: "founding-tee-xl",
        title: "XL",
        price: { amount: "50.00", currencyCode: "USD" },
        stripePriceId: "price_1T74mEJUsO4JXEemLYceLX6Z",
      },
      {
        id: "founding-tee-2xl",
        title: "2XL",
        price: { amount: "50.00", currencyCode: "USD" },
        stripePriceId: "price_1T74mEJUsO4JXEemx37xf5GB",
      },
    ],
    images: [
      {
        src: "/assets/spinnin-shirt-primary.png",
        alt: "Spinnin' Beans Founding Tee - Front",
      },
      {
        src: "/assets/spinnin-shirt-secondary.png",
        alt: "Spinnin' Beans Founding Tee - Back",
      },
    ],
    _stripe: {
      productId: "prod_TSbPnnh10XqnjL",
    },
  },
];

export default products;
